import * as React from 'react';

import * as styles from './CarouselLabels.css';
import { IPhotoLabel } from '../../types';
import { Label } from '../Label';
import { preventDefault } from '../../utils/event';

export interface ICarouselLabels {
  labels: IPhotoLabel[];
  isDealRentAgencyActive?: boolean;
  offerHref: string;
}

export const CarouselLabels: React.FC<ICarouselLabels> = ({ labels, offerHref }) => {
  return (
    <a className={styles['container']} href={offerHref} onClick={preventDefault}>
      {labels.map(label => (
        <Label key={`label_${label.name}`} {...label} />
      ))}
    </a>
  );
};
